/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';

    const constants = require('@utils/_constants');

    angular
        .module('enervee')
        .directive('utilityRateSelector', utilityRateSelectorDirective);

    function utilityRateSelectorDirective() {
        return {
            restrict:'E',
            scope: {
                isMobile: '@'
            },
            template: require('@app/shared/modals/utilityRateZipCodeSelector/zipCodeSelector.html'),
            controller: [
                '$scope',
                '$timeout',
                'AccountAuthService',
                'AnalyticsService',
                'CategoriesService',
                'PopoverService',
                'UtilitySelectorService',
                'UtilitySelectorCookieService',
                'UtilService',
                function utilityRateSelectorController(
                    $scope,
                    $timeout,
                    AccountAuthService,
                    AnalyticsService,
                    CategoriesService,
                    PopoverService,
                    UtilitySelectorService,
                    UtilitySelectorCookieService,
                    UtilService
                ) {
                    $scope.utilityProviders = null;
                    $scope.electricalUtility = UtilitySelectorCookieService.getElectricalUtility();
                    var isElectricalUtilitySet = UtilitySelectorCookieService.isElectricalUtilitySet();
                    var customRateData = {title: 'Custom Rate', user_set_electrical_rate: null};
                    var nationalAverage = {title: 'US National Average', id: 'us', electrical_rate: '11.47'};

                    /**
                     * Helper function to fetch and set utility providers.
                     * zipCode is optional. If a zipCode is not provider we fetch
                     * utility providers from the user's geoip in the backend.
                     * @param zipCode
                     * @private
                     */
                    var _setUtilityProviders = function(zipCode) {
                        UtilitySelectorService.getUtilityProviders(zipCode).then(function(utilityProviders) {
                            $scope.utilityProviders = utilityProviders;
                            if ($scope.utilityProviders.length === 0) {
                                $scope.utilityProviders.push(nationalAverage);
                            }
                            $scope.setPopoverState($scope.utilitySelectorStates.stateList);
                        });
                    };

                    /**
                     * Function that takes in a zipcode and returns a
                     * list of utilities corresponding to that zipcode
                     * @param zipCode
                     */
                    $scope.searchUtility = function(zipCode) {
                        $scope.utilityProviders = null;
                        _setUtilityProviders(zipCode);
                    };

                    /**
                     * Set a user utility. Sets utility from the utilityProviders list
                     * @param utility, zipcode
                     */
                    $scope.selectUtility = function(utility, zipCode) {
                        AnalyticsService.trackUser({
                            user_utility: utility.id
                        });
                        _setElectricalUtilityHeaderInfo(utility.title, utility.electrical_rate);

                        var utilityData = {
                            'electrical_rate': utility.electrical_rate,
                            'electrical_utility_id': utility.id,
                            'postal_code': zipCode,
                            'user_set_electrical_rate': null,
                            'electrical_utility_title': utility.title
                        };
                        UtilitySelectorCookieService.setElectricalUtility(utilityData);

                        if (AccountAuthService.isAuthenticated()) {
                            UtilitySelectorService.setElectricalUtility(utilityData);
                        } else {
                            AccountAuthService.onAuthChange($scope.selectUtility, constants.EVENT_SET_ELECTRICAL_UTILITY);
                        }
                        $scope.customRate = null;
                        isElectricalUtilitySet = true;
                        $scope.hidePopover();
                    };


                    $scope.categories = CategoriesService.getOrderedCategories();

                    /**
                     * Set user's custom rate data, utility name and rate.
                     * @param customRate
                     */
                    $scope.setCustomRate = function (customRate) {
                        $scope.hidePopover();
                        _setElectricalUtilityHeaderInfo(customRateData.title, customRate);
                        customRateData.user_set_electrical_rate = customRate;
                        UtilitySelectorCookieService.setElectricalUtility(customRateData);
                        var _activeUtilityId = 'customRate';
                        CategoriesService.getCategories(_activeUtilityId).then(function () {
                            UtilService.extendObj($scope.categories, CategoriesService.getOrderedCategories());
                        });

                        if (AccountAuthService.isAuthenticated()) {
                            UtilitySelectorService.setElectricalUtility(customRateData);
                        } else {
                            AccountAuthService.onAuthChange($scope.selectUtility, constants.EVENT_SET_ELECTRICAL_UTILITY);
                        }
                    };

                    /**
                     * Convenience function to set the chosen electrical utility info in the header.
                     * @param utility
                     * @private
                     */
                    var _setElectricalUtilityHeaderInfo = function(title, rate) {
                        var existingRate = null;
                        if ($scope.electricalUtility) {
                            existingRate = $scope.electricalUtility.electricalRate || $scope.electricalUtility.electrical_rate;
                        }
                        $scope.electricalUtility = {electrical_utility_title: title, electricalRate: rate};
                    };

                    /**
                     * Helper to identify if the user's screen is small
                     */
                    if ($scope.isMobile && ($scope.isMobile.toLowerCase() === 'true')) {
                        $scope.isMobile = true;
                    } else {
                        $scope.isMobile = false;
                    }

                    /**
                     * Utility selector popover display options
                     */
                    $scope.utilitySelectorPopover = {
                        isOpen: true,
                        isEnabled: true,
                        templateUrl: '/app/shared/popovers/zipCodeSelectorPopover.html'
                    };

                    $scope.utilitySelectorStates = {
                        stateDetail: 'detail',
                        stateList: 'list',
                        stateSearch: 'search',
                        stateCustom: 'custom'
                    };

                    /**
                     * Helper function to check the current state of the popover.
                     * @param state
                     * @returns {boolean}
                     */
                    $scope.checkPopoverState = function(state) {
                        return $scope.utilitySelectorState === state;
                    };

                    /**
                     * Helper function to show a new popover
                     * @param state
                     */
                    $scope.setPopoverState = function(state) {
                        $scope.utilitySelectorState = state;
                    };

                    /**
                     * Helper function to dismiss the popover.
                     */
                    $scope.hidePopover = function() {
                        // If a user dismisses the pop over without setting a utility, set the
                        // electrical utility to the National Average.
                        if (!UtilitySelectorCookieService.isElectricalUtilitySet()) {
                            $scope.electricalUtility = {
                                id: nationalAverage.id,
                                electricalRate: nationalAverage.electrical_rate,
                                electrical_utility_title: nationalAverage.title
                            };
                            UtilitySelectorCookieService.setElectricalUtility($scope.electricalUtility);
                        }
                        $scope.utilitySelectorPopover.isOpen = false;
                        $scope.resetPopoverState();
                    };

                    /**
                     * Helper function to toggle the popover to hide or display.
                     */
                    $scope.togglePopover = function() {
                        $scope.utilitySelectorPopover.isOpen = !$scope.utilitySelectorPopover.isOpen;
                        if (!$scope.utilitySelectorPopover.isOpen) {
                            $scope.resetPopoverState();
                        }
                    };

                    PopoverService.addPopover(
                        'utilitySelector',
                        {
                            open: function(){$scope.utilitySelectorPopover.isOpen = true;},
                            close: $scope.hidePopover,
                            toggle: $scope.togglePopover
                        }
                    );

                    $scope.setPopoverState($scope.utilitySelectorStates.stateDetail);

                    $scope.resetPopoverState = function() {
                        // Wait for fade out animations to complete
                        $timeout(function() {
                            // Don't switch states if the popover is open
                            if (!$scope.utilitySelectorPopover.isOpen) {
                                // TODO: Set to default appropriate state
                                $scope.setPopoverState($scope.utilitySelectorStates.stateDetail);
                            }
                        }, 400);
                    };

                    /**
                     * Helper function to determine if a non default utility is in the
                     * getUtilityProviders list.
                     * @param utilityProviders
                     * @returns {boolean}
                     */
                    var _containsUtility = function(utilityProviders) {
                        for (var i=0; i< utilityProviders.length; i++) {
                            var utilityId =  utilityProviders[i].id;
                            if (isFinite(String(utilityId))) {
                                return true;
                            }
                        }
                        return false;
                    };

                    /**
                     * Helper function to determine if multiple utilities were returned.
                     * State and National average do not count.
                     * @param utilityProviders
                     * @private
                     */
                    var _containsMultipleUtilities = function(utilityProviders) {
                        var utilsFound = 0;
                        for (var i=0; i< utilityProviders.length; i++) {
                            if (isFinite(String(utilityProviders[i].id))) {
                                utilsFound++;
                            }
                        }
                        return utilsFound >= 2;
                    };

                    /**
                     * Helper function to return a utility from a list of utilityProviders.
                     * State/National average are also included in utilityProviders, this
                     * function returns a non state/average utility.
                     * @private
                     */
                    var _getSingleUtility = function(utilityProviders) {
                        for (var i=0; i< utilityProviders.length; i++) {
                            if (isFinite(String(utilityProviders[i].id))) {
                                return utilityProviders[i];
                            }
                        }

                    };

                    if (!isElectricalUtilitySet) {
                        UtilitySelectorService.getUtilityProviders().then(function(utilityProviders) {
                            $scope.utilityProviders = utilityProviders;
                            if ($scope.utilityProviders && _containsUtility($scope.utilityProviders)) {
                                if (_containsMultipleUtilities($scope.utilityProviders)) {
                                    // Multiple utilities found, list the utilities
                                    $scope.setPopoverState($scope.utilitySelectorStates.stateList);
                                } else {
                                    // One utility found, display the confirmation popover box
                                    var utility = _getSingleUtility($scope.utilityProviders);
                                    _setElectricalUtilityHeaderInfo(utility.electrical_utility_title, utility.electrical_rate);
                                    $scope.setPopoverState($scope.utilitySelectorStates.stateDetail);
                                }
                            } else {
                                // GEOIP did not find a utility - Display the Zip entry popover box
                                $scope.setPopoverState($scope.utilitySelectorStates.stateSearch);
                            }

                        });
                    } else {
                        // User has set a utility, hide the popover and set the utility info in the header
                        $scope.hidePopover();
                        var utility =  UtilitySelectorCookieService.getElectricalUtility();
                        if ('user_set_electrical_rate' in utility && utility.user_set_electrical_rate !== null) {
                            _setElectricalUtilityHeaderInfo(customRateData.title, utility.user_set_electrical_rate);
                        } else if ('electricalRate' in utility && utility.electricalRate !== null) {
                            _setElectricalUtilityHeaderInfo(utility.electrical_utility_title, utility.electricalRate);
                        } else if('residential_rate' in utility && utility.residential_rate !== null) {
                            _setElectricalUtilityHeaderInfo(utility.electrical_utility_title, utility.residential_rate);
                        } else if('electrical_rate' in utility && utility.electrical_rate !== null) {
                            _setElectricalUtilityHeaderInfo(utility.electrical_utility_title, utility.electrical_rate);
                        }
                        $scope.setPopoverState($scope.utilitySelectorStates.stateDetail);
                    }
                }
            ]
        };
    }
})(angular);
